<template lang="pug">

.safe-area-bottom(:style="wrapperStyle")

</template>

<script>
// 全面屏 - 底部高度适配(手机底部关闭条纹)
export default {
  props: {
    background: { require: false, type: String, default: "" }
  },

  computed: {
    wrapperStyle() {
      let style = {}

      if (this.background) {
        style.background = this.background
      }

      return style
    }
  }
}
</script>

<style lang="stylus" scoped>
.safe-area-bottom
  height constant(safe-area-inset-bottom)
  height env(safe-area-inset-bottom)
</style>
